import(/* webpackMode: "eager" */ "/app/src/app/interview/page.tsx");
